// Part List Type options
export const partListTypeOptions = [
  { key: "mylist", label: "MYLIST" },
  { key: "picklist", label: "User Pick List" },
  { key: "kpad", label: "Kubota KPAD" },
  { key: "opv", label: "CNH" },
  { key: "psmart", label: "Part Smart" },
  { key: "pmpro", label: "PM Pro" },
  { key: "bass", label: "Bobcat OPC" },
  { key: "epsilon", label: "Epsilon" },
  { key: "workorder", label: "Work Order" },
];

// Unit List Type options
export const unitListTypeOptions = [
  { key: "", label: "" },
  { key: "myunitlist", label: "My List" },
  { key: "unitlist", label: "User Pick List" },
];
export const DAYS = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
] as const;

export const WEEK_DAYS_MON_FRI = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
] as const;
